import { render, staticRenderFns } from "./CollectListLink.vue?vue&type=template&id=5d2f6999&scoped=true&"
import script from "./CollectListLink.vue?vue&type=script&lang=js&"
export * from "./CollectListLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2f6999",
  null
  
)

export default component.exports